import {
  mockBankService,
  mockCurrencyService,
  mockDepartmentService,
  mockEmployeeFormService,
  mockEmployeeTimeOffService,
  mockEmployeeWorkgroupService,
  mockGLAccountService,
  mockInvoiceService,
  mockItemCommercialTranslationService,
  mockItemService,
  mockMaintenanceService,
  mockPaymentPlanService,
  mockPriceSnapshotService,
  mockQuoteService,
  mockQuoteServiceVariableService,
  mockRequisitionService,
  mockSalesRepService,
  mockTariffService,
  mockTaxService,
  mockTimeOffService,
  mockVendorService
} from '@/services';

import { mockEmployeeService } from '../employee';
import { mockFileLoaderService } from '../fileloader';
import { mockHrDepartmentService } from '../hr-department';
import {
  mockQuoteFreightTemplateService,
  mockQuotePaymentTermTemplateService,
  mockQuoteServiceTemplateService,
  mockQuoteTermTemplateService
} from '../quotetemplate';
import { mockTimeOffCalendarService } from '../timeoff-calendar';
import { mockTimeOffRequestService } from '../timeoff-request';
import { mockInventoryAdvancePaymentService } from '../inventory-advance-payment';
import { mockPayrollChangeRequestService } from '../payrollchangerequest';
import { mockItemTagService } from '../item-tag';
import { mockOrderService } from '../order';
import { mockWorkgroupService } from '../workgroup';
import { IProviderMock } from './provider.mock.types';
import { mockVacationCarryOverRequestService } from '../vacation-carry-over-request';
import { mockOvertimeRequestService } from '../overtime-request';
import { mockFormTemplateService } from '../form-template';
import { mockQuotePaymentTermCodeService } from '../quote-payment-term-code';
import { mockQuoteProductService } from '../document/mock/document.mock';
import { mockPaymentRequisitionService } from '../payment-requisition';
import { mockContractService } from '../contract/__mocks__';
import { mockWorkflowService } from '../workflow/__mocks__';
import { mockWorkflowFormService } from '../workflow-form';
import { mockWorkflowFormTemplateService } from '../workflow-form-template';
import { mockHarmonizedSystemService } from '../harmonized-system';
import { mockTariffMandatoryItemService } from '../tariff-mandatory-item';

export const mockProvider = (): IProviderMock => ({
  accounting: mockGLAccountService(),
  bank: mockBankService(),
  timeOffCalendar: mockTimeOffCalendarService(),
  contract: mockContractService(),
  currency: mockCurrencyService(),
  department: mockDepartmentService(),
  document: mockQuoteProductService(),
  employee: mockEmployeeService(),
  employeeForm: mockEmployeeFormService(),
  employeeTimeOff: mockEmployeeTimeOffService(),
  employeeWorkgroup: mockEmployeeWorkgroupService(),

  formTemplate: mockFormTemplateService(),
  fileLoader: mockFileLoaderService(),
  invoice: mockInvoiceService(),
  item: mockItemService(),
  itemCommercialTranslation: mockItemCommercialTranslationService(),
  hrDepartment: mockHrDepartmentService(),
  priceSnapshot: mockPriceSnapshotService(),
  maintenance: mockMaintenanceService(),
  overtimeRequest: mockOvertimeRequestService(),
  inventoryAdvancePayment: mockInventoryAdvancePaymentService(),
  paymentRequisition: mockPaymentRequisitionService(),
  payrollChangeRequest: mockPayrollChangeRequestService(),
  paymentPlan: mockPaymentPlanService(),
  tariff: mockTariffService(),
  harmonizedSystem: mockHarmonizedSystemService(),

  tax: mockTaxService(),
  timeOff: mockTimeOffService(),
  timeOffRequest: mockTimeOffRequestService(),
  itemTag: mockItemTagService(),
  order: mockOrderService(),

  // Quote Templates
  quoteFreightTemplate: mockQuoteFreightTemplateService(),
  quotePaymentTermTemplate: mockQuotePaymentTermTemplateService(),
  quotePaymentTermCode: mockQuotePaymentTermCodeService(),
  quoteServiceTemplate: mockQuoteServiceTemplateService(),

  // Quote service variable
  quoteServiceVariable: mockQuoteServiceVariableService(),
  quoteTermTemplate: mockQuoteTermTemplateService(),
  quote: mockQuoteService(),
  requisition: mockRequisitionService(),
  salesRep: mockSalesRepService(),
  vendor: mockVendorService(),
  vacationCarryOverRequest: mockVacationCarryOverRequestService(),

  workgroup: mockWorkgroupService(),
  workflow: mockWorkflowService(),

  workflowForm: mockWorkflowFormService(),
  workflowFormTemplate: mockWorkflowFormTemplateService(),
  tariffMandatoryItem: mockTariffMandatoryItemService()
});
